import React, { useEffect, useState } from "react";
import Banner from "../../components/Banner";
import axios from "../../utils/request";
import "./index.css";
import { useNavigate } from "react-router-dom";

const NewsPage = () => {
  const [news, setNews] = useState<any>([]);
  useEffect(() => {
    const initData = async () => {
      const res: any = await axios.get("/index/news");
      if (res.code === 200) {
        setNews(res.data.data);
      }
    };
    initData();
  }, []);
  const navigate = useNavigate();
  return (
    <div className="news-box">
      <Banner />
      <div className="nb-ul">
        {news?.map((item: any) => {
          return (
            <div
              className="nb-li"
              onClick={() => {
                navigate("/detail", {
                  state: {
                    url: "/index/news/detail",
                    id: item?.id,
                  },
                });
              }}
            >
              <img className="nb-li-img" src={item?.img} />
              <div className="nb-li-content">
                <div className="nb-li-c-title">{item?.title}</div>
                <div className="nb-li-c-desc">{item?.detail}</div>
                <div className="nb-li-c-time">{item?.created_time}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NewsPage;
